import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { MdTranslate } from "react-icons/md";
import { IoMusicalNotes } from "react-icons/io5";
import api from "../../services/api";
import "./Header.css";

const Header = () => {
  const [menuOpen, setMenuOpen] = useState(false);
  const [openDropdown, setOpenDropdown] = useState(null);
  // eslint-disable-next-line no-unused-vars
  const [isSticky, setIsSticky] = useState(false);
  const [showPlayer, setShowPlayer] = useState(false);
  const [admissionSettings, setAdmissionSettings] = useState([]);

  const isExternalLink = (url) => {
    if (!url) return false;
    return url.startsWith("http://") || url.startsWith("https://") || url.startsWith("//");
  };

  const toggleMenu = () => {
    setMenuOpen(!menuOpen);
  };

  const toggleDropdown = (menu) => {
    setOpenDropdown(openDropdown === menu ? null : menu);
  };

  useEffect(() => {
    const fetchAdmissionSettings = async () => {
      try {
        const response = await api.get("/public/cms/admission_settings");
        const items = response.data?.data || [];
        setAdmissionSettings(items);
      } catch (error) {
        console.error("Error fetching admission menu settings:", error);
      }
    };
    fetchAdmissionSettings();
  }, []);

  useEffect(() => {
    const handleScroll = () => {
      setIsSticky(window.scrollY > 10);
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  return (
    <header className="header">
      <div className="container-fluid header-container">
        {/* Logo */}
        <div className="logo-section">
          <Link
            to="/"
            onClick={() => setMenuOpen(false)}
            aria-label="IHM Mumbai Homepage"
          >
            <img
              src="/images/logo.png"
              alt="Institute of Hotel Management, Mumbai Logo"
              className="logo"
            />
          </Link>
        </div>

        {/* Desktop Navigation */}
        <nav className="desktop-nav">
          {/* The Institute */}
          <div className="nav-item dropdown">
            <span className="nav-link">
              The Institute
              <i className="bi bi-chevron-down dropdown-arrow"></i>
            </span>

            <div className="dropdown-menu-custom">
              <div className="dropdown-list">
                <Link to="/campus">Our Campus</Link>
                <Link to="/faculty">Faculty </Link>
                <Link to="/administrativestaff">Administrative Staff</Link>
                <Link to="https://www.dihmaa.org/">Alumni</Link>
                <Link to="/pastprincipals">Past Principals</Link>
                <Link to="/rti">RTI</Link>
              </div>
            </div>
          </div>

          <Link to="/courses" className="nav-link">
            Courses
          </Link>

          {/* Students */}
          <div className="nav-item dropdown">
            <span className="nav-link">
              Students
              <i className="bi bi-chevron-down dropdown-arrow"></i>
            </span>

            <div className="dropdown-menu-custom">
              <div className="dropdown-list">
                <Link to="/notice-board">Notice Board</Link>
                <Link to="/fee">Fees</Link>
                <Link to="/results">Result</Link>
                <Link to="/ignou">Ignou</Link>
              </div>
            </div>
          </div>

          <Link to="/tenders" className="nav-link">
            Tenders
          </Link>
          <div className="nav-item dropdown">
            <span className="nav-link">
              About Us
              <i className="bi bi-chevron-down dropdown-arrow"></i>
            </span>

            <div className="dropdown-menu-custom">
              <div className="dropdown-list">
                <Link to="/about">About Us</Link>
                <Link to="/events">Events</Link>
              </div>
            </div>
          </div>

         

          <Link to="/contact" className="nav-link">
            Contact Us
          </Link>

          {admissionSettings.map((setting) => (
            isExternalLink(setting.metadata?.link_url) ? (
              <a
                key={setting.id}
                href={setting.metadata.link_url}
                className="nav-link"
                target="_blank"
                rel="noreferrer"
              >
                {setting.title}
                {setting.metadata?.badge_text && (
                  <sup className="admission-badge">{setting.metadata.badge_text}</sup>
                )}
              </a>
            ) : (
              <Link
                key={setting.id}
                to={setting.metadata?.link_url || "/admissions"}
                className="nav-link"
              >
                {setting.title}
                {setting.metadata?.badge_text && (
                  <sup className="admission-badge">{setting.metadata.badge_text}</sup>
                )}
              </Link>
            )
          ))}
        </nav>

        {/* Desktop Icons */}
        {/* <div className="icon-section">
          <a href="mailto:admissions@ihmctan.edu" className="icon-circle">
            <i className="bi bi-envelope"></i>
          </a>

          <a href="tel:+912245284100" className="icon-circle">
            <i className="bi bi-telephone"></i>
          </a>
        </div> */}
        <div className="icon-section">
          {/* Mail */}
          <a
            href="mailto:director@ihmctan.edu"
            className="icon-circle"
            aria-label="Email Admissions"
          >
            <i className="bi bi-envelope" aria-hidden="true"></i>
          </a>

          {/* Phone */}
          <a
            href="tel:+912245284100"
            className="icon-circle"
            aria-label="Call Admissions"
          >
            <i className="bi bi-telephone" aria-hidden="true"></i>
          </a>

          {/* Translate */}
          <div className="translate-dropdown">
            <button
              className="icon-circle translate-toggle"
              aria-label="Translate Website Language"
            >
              <MdTranslate aria-hidden="true" />
            </button>

            <div className="translate-dropdown-menu">
              <button
                onClick={() =>
                  window.open(
                    `https://translate.google.com/translate?sl=auto&tl=en&u=${encodeURIComponent(window.location.href)}`,
                    "_blank",
                  )
                }
              >
                English
              </button>

              <button
                onClick={() =>
                  window.open(
                    `https://translate.google.com/translate?sl=auto&tl=hi&u=${encodeURIComponent(window.location.href)}`,
                    "_blank",
                  )
                }
              >
                हिंदी
              </button>

              <button
                onClick={() =>
                  window.open(
                    `https://translate.google.com/translate?sl=auto&tl=mr&u=${encodeURIComponent(window.location.href)}`,
                    "_blank",
                  )
                }
              >
                मराठी
              </button>
            </div>
          </div>
          <div className="translate-dropdown">
            <button
              className="icon-circle translate-toggle"
              aria-label="Institute Media"
            >
              <IoMusicalNotes />
            </button>

            <div className="translate-dropdown-menu">
              <a
                href="/images/College-Anthem.pdf"
                target="_blank"
                rel="noreferrer"
                className="translate-option"
              >
                View PDF
              </a>

              <button
                className="translate-option"
                onClick={() => setShowPlayer(!showPlayer)}
              >
                Play Anthem
              </button>

              {showPlayer && (
                <div style={{ padding: "10px" }}>
                  <audio controls autoPlay style={{ width: "100%" }}>
                    <source
                      src="/images/college_anthem-audio.mp3"
                      type="audio/mpeg"
                    />
                    Your browser does not support audio.
                  </audio>
                </div>
              )}
            </div>
          </div>
        </div>

        {/* Mobile Hamburger */}
        <button
          className="mobile-menu-icon"
          onClick={toggleMenu}
          aria-label="Open Navigation Menu"
          aria-expanded={menuOpen}
          style={{ background: "none", border: "none", padding: 0 }}
        >
          <img src="/images/hamburger.png" alt="" aria-hidden="true" />
        </button>
      </div>

      {/* Overlay */}
      <div
        className={`menu-overlay ${menuOpen ? "active" : ""}`}
        onClick={() => setMenuOpen(false)}
      ></div>

      {/* Mobile Drawer */}
      <div className={`mega-menu ${menuOpen ? "active" : ""}`}>
        <button
          className="close-menu"
          onClick={() => setMenuOpen(false)}
          aria-label="Close Navigation Menu"
          style={{ background: "none", border: "none", padding: 0 }}
        >
          <i className="bi bi-x-lg" aria-hidden="true"></i>
        </button>

        <div className="mega-container single-menu">
          {/* The Institute */}
          <div
  className={`mobile-dropdown ${
    openDropdown === "institute" ? "dropdown-active" : ""
  }`}
>
            <div
              className="mobile-dropdown-header"
              onClick={() => toggleDropdown("institute")}
            >
              The Institute
              <i
                className={`bi ${openDropdown === "institute" ? "bi-chevron-up" : "bi-chevron-down"}`}
              ></i>
            </div>

            <div
              className={`mobile-dropdown-content ${openDropdown === "institute" ? "open" : ""}`}
            >
              <Link to="/campus" onClick={() => setMenuOpen(false)}>
                Our Campus
              </Link>
              <Link to="/faculty" onClick={() => setMenuOpen(false)}>
                Faculty
              </Link>
              <Link
                to="/administrativestaff"
                onClick={() => setMenuOpen(false)}
              >
                Administrative Staff
              </Link>
             
              <Link
                to="https://www.dihmaa.org/"
                onClick={() => setMenuOpen(false)}
              >
                Alumni
              </Link>
              <Link to="/pastprincipals" onClick={() => setMenuOpen(false)}>
                Past Principals
              </Link>
               <Link to="/rti" onClick={() => setMenuOpen(false)}>
                RTI
              </Link>
              
            </div>
          </div>

          {/* Courses */}
          <Link
            to="/courses"
            className="mega-link"
            onClick={() => setMenuOpen(false)}
          >
            Courses
          </Link>

          {/* Students */}
         <div
  className={`mobile-dropdown ${
    openDropdown === "students" ? "dropdown-active" : ""
  }`}
>
            <div
              className="mobile-dropdown-header"
              onClick={() => toggleDropdown("students")}
            >
              Students
              <i
                className={`bi ${openDropdown === "students" ? "bi-chevron-up" : "bi-chevron-down"}`}
              ></i>
            </div>

            <div
              className={`mobile-dropdown-content ${openDropdown === "students" ? "open" : ""}`}
            >
              <Link to="/notice-board" onClick={() => setMenuOpen(false)}>
                Notice Board
              </Link>

              <Link to="/fee" onClick={() => setMenuOpen(false)}>
                Fees
              </Link>
              <Link to="/results" onClick={() => setMenuOpen(false)}>
                Result
              </Link>
              <Link to="/ignou" onClick={() => setMenuOpen(false)}>
                IGNOU
              </Link>
            </div>
          </div>

          <Link
            to="/tenders"
            className="mega-link"
            onClick={() => setMenuOpen(false)}
          >
            Tenders
          </Link>

          <div
  className={`mobile-dropdown ${
    openDropdown === "about" ? "dropdown-active" : ""
  }`}
>
            <div
              className="mobile-dropdown-header"
              onClick={() => toggleDropdown("about")}
            >
              About US
              <i
                className={`bi ${openDropdown === "about" ? "bi-chevron-up" : "bi-chevron-down"}`}
              ></i>
            </div>

            <div
              className={`mobile-dropdown-content ${openDropdown === "about" ? "open" : ""}`}
            >
              <Link to="/about" onClick={() => setMenuOpen(false)}>
                About Us
              </Link>

              <Link to="/events" onClick={() => setMenuOpen(false)}>
                Events
              </Link>
            </div>
          </div>

          

          <Link
            to="/contact"
            className="mega-link"
            onClick={() => setMenuOpen(false)}
          >
            Contact Us
          </Link>
          {admissionSettings.map((setting) => (
            isExternalLink(setting.metadata?.link_url) ? (
              <a
                key={setting.id}
                href={setting.metadata.link_url}
                className="mega-link"
                target="_blank"
                rel="noreferrer"
                onClick={() => setMenuOpen(false)}
              >
                {setting.title}
                {setting.metadata?.badge_text && (
                  <sup className="admission-badge">{setting.metadata.badge_text}</sup>
                )}
              </a>
            ) : (
              <Link
                key={setting.id}
                to={setting.metadata?.link_url || "/admissions"}
                className="mega-link"
                onClick={() => setMenuOpen(false)}
              >
                {setting.title}
                {setting.metadata?.badge_text && (
                  <sup className="admission-badge">{setting.metadata.badge_text}</sup>
                )}
              </Link>
            )
          ))}
        </div>
      </div>
    </header>
  );
};

export default Header;
